<template>
  <q-dialog
    v-model="dialogModel"
    color="secondary"
    :cancel="true"
    prevent-close
  >
    <span slot="title">{{ $t('discount_dialog_header') }}</span>

    <span slot="message" v-html="$t('discount_dialog_content')"></span>

    <div slot="body">
      <discount-input
        :currency="currency"
        :discount-absolute="discount.abs"
        :discount-relative="discount.rel"
        @inputDiscountAbsolute="discount.abs = $event"
        @inputDiscountRelative="discount.rel = $event"
      />
    </div>

    <template slot="buttons" slot-scope="props">
      <q-btn :label="$t('cancel')" flat @click="handleCancel(props.cancel)" />
      <q-btn :label="$t('ok')" :disabled="!hasDiscount" flat @click="handleAdd(props.ok)" />
    </template>
  </q-dialog>
</template>

<script>
  import DiscountInput from 'components/Common/Inputs/DiscountInput.vue'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data () {
      return {
        dialogModel: false,
        discount: {
          abs: null,
          rel: null
        }
      }
    },

    props: {
      currency: {
        type: String,
        required: true
      }
    },

    computed: {
      discountType () {
        if (this.discount.abs !== null && this.discount.rel === null) {
          return 'abs'
        } else if (this.discount.rel !== null && this.discount.abs === null) {
          return 'rel'
        }

        return null
      },

      hasDiscount () {
        return this.discount.abs || this.discount.rel
      }
    },

    methods: {
      open () {
        this.dialogModel = true
      },

      handleAdd (okFn) {
        if (this.hasDiscount) {
          const data = {
            value: this.discount[this.discountType],
            type: this.discountType
          }

          this.$emit('discount', data)
          this.resetData()
          okFn()
        }
      },

      handleCancel (cancelFn) {
        cancelFn()
        this.resetData()
      },

      resetData () {
        this.discount = {
          abs: null,
          rel: null
        }
      }
    },

    components: {
      DiscountInput
    }
  }
</script>
